export const lokiStream = {
  type: "object",
  required: ["stream", "values"],
  properties: {
    stream: {
      type: "object"
    },
    values: {
      type: "array",
      minItems: 0,
      maxItems: 1_024,
      items: {
        type: "array",
        minItems: 2,
        maxItems: 3
      }
    }
  }
};
